module.exports = __webpack_public_path__ + "static/media/table-grey.5a9afb90.png";